import { render, staticRenderFns } from "./adminApp.vue?vue&type=template&id=22ec0b80&scoped=true&"
import script from "./adminApp.vue?vue&type=script&lang=js&"
export * from "./adminApp.vue?vue&type=script&lang=js&"
import style0 from "./adminApp.vue?vue&type=style&index=0&id=22ec0b80&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec0b80",
  null
  
)

export default component.exports